export default {
  namespaced: true,
  state: {
    personalInfo: null,
    location: null,
    transcript: null,
    currentStep: 1,
  },
  getters: {
    isInfoSet(state){
      return !!state.personalInfo
    },
    grade(state){
      return state.personalInfo ? state.personalInfo.grade : 7;
    },
    personalInfo(state) {
      return state.personalInfo
    },
    location(state) {
      return state.location
    },
    transcript(state) {
      return state.transcript
    },
    currentStep(state) {
      return state.currentStep
    }
  },
  mutations:{
    SET_PERSONAL_INFO(state, val){
      state.personalInfo = val
    },
    SET_LOCATION(state, val){
      state.location = val
    },
    SET_TRANSCRIPT(state, val){
      state.transcript = val
    },
    SET_CURRENT_STEP(state, val){
      state.currentStep = val
    },
  },
  actions:{
    updatePersonalInfo(context, payload){
      context.commit('SET_PERSONAL_INFO', payload)
    },
    updateLocation(context, payload){
      context.commit('SET_LOCATION', payload)
    },
    updateTranscript(context, payload){
      context.commit('SET_TRANSCRIPT', payload)
    },
    nextStep(context){
      context.commit('SET_CURRENT_STEP',++context.state.currentStep)
    },
    prevStep(context){
      context.commit('SET_CURRENT_STEP',--context.state.currentStep)
    }
  },
}
